/* eslint-disable */
export default {
  dncAlert: 'Questo contatto è in un elenco "Non chiamare".',
} as const;

// @key: @#@"dncAlert"@#@ @source: @#@"This contact is on a Do Not Call list."@#@
